import {svgIconWrapper} from '../svg-icon-wrapper';

import StripeRegular from './stripe-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <StripeRegular {...rest} />;
}

SvgComponent.iconName = 'stripeRegular';

export const StripeRegularIcon = svgIconWrapper(SvgComponent);
